import React from 'react';
import './Footer.css';
import logo from '../Navbar/logo.png';

import { useTranslation } from 'react-i18next';

const Footer = () => {

    const { t } = useTranslation();

    return (
        <section className="footer">
            <div className='content-wrap'>
                <div className="footer-grid d-flex">
                    <div className="footer-grid_logo d-flex space-center">
                        <img className='img-logo' src={logo} alt="logo"/>
                        <p>ТРАНЗІТ ТРАК</p>
                    </div>
                    <div className='footer-grid_list'>
                        <nav>
                            <ul>
                                <li>
                                    <i className="fa-solid fa-phone-volume"></i>
                                    <a href="tel:+380503526543">+38 (050) 352-65-43</a>
                                </li>
                                <li>
                                    <i className="fa-solid fa-phone-volume"></i>
                                    <a href="tel:+380504107644">+38 (050) 410-76-44</a>
                                </li>
                                <li>
                                    <i className="fa-solid fa-location-dot"></i>
                                    <a href='https://www.google.com.ua/maps/dir//50.4481301,29.7533212/@50.4489923,29.7522312,1099m/data=!3m1!1e3?hl=uk&entry=ttu&g_ep=EgoyMDI1MDYxNy4wIKXMDSoASAFQAw%3D%3D' target="_blank" rel="noopener noreferrer">{t('location')}</a>
                                </li>
                                <li>
                                    <i className="fa-solid fa-envelope"></i>
                                    <a href="mailto:tranzittrak@ukr.net">tranzittrak@ukr.net</a>
                                </li>
                                <li>
                                    <a href="https://facebook.com">
                                        <i className="fa-brands fa-facebook"></i>
                                    </a>
                                    <a href="https://www.instagram.com">
                                        <i className="fa-brands fa-instagram"></i>
                                    </a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Footer;